(function () {
  function extractQty(text) {
    const m = String(text).match(/(\d+)/);
    return m ? parseInt(m[1], 10) : null;
  }

  function syncTable(qty) {
    document.querySelectorAll('.product__description table').forEach(function (table) {
      table.querySelectorAll('tr').forEach(function (row) {
        const cell = row.querySelector('td:first-child');
        if (!cell) return;
        const cellQty = parseInt(cell.textContent.trim(), 10);
        row.classList.toggle('pricing-row--active', !isNaN(cellQty) && cellQty === qty);
      });
    });
  }

  // 「入数」fieldsetを返す
  function getQtyGroup() {
    const groups = document.querySelectorAll('.product-form__input');
    for (const group of groups) {
      const legend = group.querySelector('.form__label');
      if (legend && legend.textContent.includes('入数')) return group;
    }
    return null;
  }

  // 入数オプションの position（1始まり）を返す
  // ラジオの name が "入数-2" のような形式なので末尾の数字を使う
  function getQtyOptionPosition() {
    const group = getQtyGroup();
    if (!group) return 1;
    const radio = group.querySelector('input[type="radio"]');
    if (radio) {
      const m = radio.name.trim().match(/-(\d+)$/);
      if (m) return parseInt(m[1], 10);
    }
    // dropdownの場合
    const sel = group.querySelector('select');
    if (sel) {
      const m = sel.id.match(/-(\d+)$/);
      if (m) return parseInt(m[1], 10);
    }
    return 1;
  }

  function getInitialQty() {
    const group = getQtyGroup();
    if (group) {
      const checked = group.querySelector('input[type="radio"]:checked');
      if (checked) return extractQty(checked.value);
      const sel = group.querySelector('select');
      if (sel) return extractQty(sel.value);
    }
    // フォールバック: 最初のチェック済みラジオ
    const checked = document.querySelector('.product-form__input input[type="radio"]:checked');
    return checked ? extractQty(checked.value) : null;
  }

  document.addEventListener('DOMContentLoaded', function () {
    const initQty = getInitialQty();
    if (initQty) syncTable(initQty);

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        const variant = event.data && event.data.variant;
        if (!variant) return;
        // 入数 = option{position} を動的に参照
        const position = getQtyOptionPosition();
        const optionValue = variant['option' + position];
        const qty = extractQty(optionValue);
        if (qty != null) syncTable(qty);
      });
    }
  });
})();
